import { render, staticRenderFns } from "./GopChooseLanguage.vue?vue&type=template&id=1304ddac&scoped=true"
import script from "./GopChooseLanguage.vue?vue&type=script&lang=js"
export * from "./GopChooseLanguage.vue?vue&type=script&lang=js"
import style0 from "./GopChooseLanguage.vue?vue&type=style&index=0&id=1304ddac&lang=scss"
import style1 from "./GopChooseLanguage.vue?vue&type=style&index=1&id=1304ddac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304ddac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1304ddac')) {
      api.createRecord('1304ddac', component.options)
    } else {
      api.reload('1304ddac', component.options)
    }
    module.hot.accept("./GopChooseLanguage.vue?vue&type=template&id=1304ddac&scoped=true", function () {
      api.rerender('1304ddac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/gop-redesign/pages/GopChooseLanguage.vue"
export default component.exports